export class SumupGroup {
  id: number
  school_id: number
  exec_date: string
  name: string
  passing_score: string
  result_publish_start_datetime_at: string
  result_publish_end_datetime_at: string

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.school_id = sumupGroup.school_id;
    this.exec_date = sumupGroup.exec_date;
    this.name = sumupGroup.name;
    this.passing_score = sumupGroup.passing_score;
    this.result_publish_start_datetime_at = sumupGroup.result_publish_start_datetime_at;
    this.result_publish_end_datetime_at = sumupGroup.result_publish_end_datetime_at;
  }
}

export class SumupUnit {
  id: number
  name: string

  constructor(x: any){
    this.id = x.id;
    this.name = x.name;
  }
}

export class RankResult {
  practice_examinee_id: number
  room_name: string
  student_no_character: string
  student_name: string
  gender: number
  sumupUnitResults: SumupUnitResult[]
  addition: string
  rowObject: any = {}
  colCount: number
  scoreKeys: number[] = []
  rankKeys: number[] = []
  stdScoreKeys: number[] = []
  assessmentKeys: number[] = []
  result_published: boolean
  result_published_cache: boolean
  assessment_values: string[]
  isSelected: boolean = false

  constructor(rankResult: any){
    this.practice_examinee_id = rankResult.practice_examinee_id;
    this.room_name = rankResult.room_name;
    this.student_no_character = rankResult.student_no_character;
    this.student_name = rankResult.student_name;
    this.gender = rankResult.gender;
    this.sumupUnitResults = rankResult.sumup_unit_results.map((x: any) => new SumupUnitResult(x));
    this.addition = rankResult.addition;
    this.result_published = rankResult.result_published;
    this.result_published_cache = rankResult.result_published;
    this.assessment_values = rankResult.assessment_values;
  }
}

export class SumupUnitResult {
  sumup_unit_id: number
  score: string
  total_rank: string
  total_std_score: string
  gender_score: string
  gender_rank: string
  gender_std_score: string

  constructor(sumupUnitResult: any){
    this.sumup_unit_id = sumupUnitResult.sumup_unit_id;
    this.score = sumupUnitResult.score;
    this.total_rank = sumupUnitResult.total_rank;
    this.total_std_score = sumupUnitResult.total_std_score.toFixed(1);
    this.gender_score = sumupUnitResult.gender_score;
    this.gender_rank = sumupUnitResult.gender_rank;
    this.gender_std_score = sumupUnitResult.gender_std_score.toFixed(1);
  }
}

export class SearchCondtion {
  student_name: string = ""
  student_no_character: string = ""
}

export class AverageResult {
  curriculum_name: string
  avg_score: number
 
  constructor(averageResult: any){
    this.curriculum_name = averageResult.curriculum_name;
    this.avg_score = averageResult.avg_score;
  }
}

export class Assessment {
  id: number
  sumup_unit_id: number
  is_gender_separate: boolean = false
  name: string
  sort_no: string
  score_type: number = 1
  result_published: boolean = true
  assessment_scores: AssessmentScore[] = []

  constructor(base_assessments: BaseAssessment[], assessment: any = null, assessment_scores: any[] = null){

    if(assessment){
      this.id = assessment.id;
      this.sumup_unit_id = assessment.sumup_unit_id;
      this.is_gender_separate = assessment.is_gender_separate;
      this.name = assessment.name;
      this.sort_no = assessment.sort_no;
      this.score_type = assessment.score_type;
      this.result_published = assessment.result_published;
      const target_assessment_scores = assessment_scores.filter((x: any) => x.assessment_id == this.id).sort((a: any, b: any) => a.sort_no - b.sort_no);
      
      this.assessment_scores = target_assessment_scores.map((x: any) => {
        const base_assessment = base_assessments.filter((y => y.id == x.base_assessment_id))[0];
        return new AssessmentScore(base_assessment, x);
      });
    }else{
      base_assessments.forEach(x => {
        this.assessment_scores.push(new AssessmentScore(x));
      });
    }
  }
}

export class AssessmentScore {
  id: number
  assessment_id: number
  base_assessment_id: number
  name: string
  sort_no: number
  total_score: string
  man_score: string
  woman_score: string
  comment: string

  constructor(base_assessment: BaseAssessment, assessment_score: any = null){
    if(assessment_score){
      this.id = assessment_score.id;
      this.base_assessment_id = assessment_score.base_assessment_id;
      this.assessment_id = assessment_score.assessment_id;
      this.sort_no = assessment_score.sort_no;
      this.total_score = assessment_score.total_score;
      this.man_score = assessment_score.man_score;
      this.woman_score = assessment_score.woman_score;
      this.comment = assessment_score.comment;
    }

    this.base_assessment_id = base_assessment.id;
    this.name = base_assessment.name;
    this.sort_no = base_assessment.sort_no;
  }
}

export class AssessmentExaminee {
  assessment_id: number
  assessment_score_id: number
  practice_examinee_id: number

  constructor(assessment_examinee: any){
    this.assessment_id = assessment_examinee.assessment_id;
    this.assessment_score_id = assessment_examinee.assessment_score_id;
    this.practice_examinee_id = assessment_examinee.practice_examinee_id;
  }
}

export class BaseAssessment {
  id: number
  name: string
  sort_no: number

  constructor(x: any){
    this.id = x.id;
    this.name = x.name;
    this.sort_no = x.sort_no;
  }
}